import useStores from 'shared/hooks/use-stores';
export default function useUI() {
  var _useStores = useStores(),
    UI = _useStores.UI;
  return UI;
}